import { render, staticRenderFns } from "./MedalCard.vue?vue&type=template&id=30a3c801&scoped=true"
import script from "./MedalCard.vue?vue&type=script&lang=js"
export * from "./MedalCard.vue?vue&type=script&lang=js"
import style0 from "./MedalCard.vue?vue&type=style&index=0&id=30a3c801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a3c801",
  null
  
)

export default component.exports